import {Image, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';
const {Text} = Typography;
const Content = Layout;

const EGA = () => {
  return (
    <Layout style={{borderStyle: 'solid', borderWidth: '2vh', margin: '-2vh -2vh -2vh -2vh', background: appColors['ColorG2'], borderTopColor: appColors['ColorX'], borderBottomColor: appColors['ColorX'], borderRightColor: appColors['ColorX'], borderLeftColor: appColors['ColorX']}}>
      <Layout style={{background: 'transparent', margin: '5.2vh 5.2vh 5.2vh 5.2vh'}}>
        <Content style={{background: 'inherit'}}>
          <Text className='BaseText6'>Electrophoresis gel with AuNPs: This protocol will be done to confirm that the incubation of the aptamer modified with thiol binds correctly to the AuNPs. We expect to see in an agarose gel a line with a red blot near the well (corresponding to the AuNPs), a line with a red blot that moved beyond the well (corresponding to the complex aptamer-AuNPs) and another line for the aptamer alone.</Text>
          <Layout style={{background: 'transparent'}}>
            <Content style={{marginLeft: '50%', transform: 'translateX(-50%)', marginTop: '2vh', width: '60vh', background: 'transparent'}}>
              <Image src='https://static.igem.wiki/teams/4464/wiki/wet-lab/10.png' preview={false}/>
              <p style={{textAlign: 'center'}}>Fig 9. Diagram of electrophoresis gel with AuNPs.<br/>Created with BioRender.com</p>
            </Content>
          </Layout>
        </Content>
      </Layout>
    </Layout>
  );
};

export default EGA;
